module.exports = __webpack_public_path__ + "static/media/AlertDemo2.9ba6b0a8.jpg";